import React, { useMemo } from 'react';
import type { RoutesPaths } from '@shared/core';
import { RoutesProvider, useRouterHelper } from '@shared/core';

export type RoutesNames = 'guestRegistry' | 'purchase' | 'retailerRedirect' | 'contribute' | 'shoppingCart' | 'itemCheckout' | 'cartCheckout' | 'accommodations';

export const routePaths: RoutesPaths<RoutesNames> = {
  guestRegistry: {
    path: '',
    goToPath: () => 'registry',
  },
  purchase: {
    path: 'purchase',
    goToPath: () => 'purchase',
  },
  accommodations: {
    path: 'accommodations',
    goToPath: () => 'accommodations',
  },
  retailerRedirect: {
    path: 'retailer-redirect',
    goToPath: () => 'retailer-redirect',
  },
  contribute: {
    path: 'contribute',
    goToPath: () => 'contribute',
  },
  shoppingCart: {
    path: 'shopping-cart',
    goToPath: () => 'shopping-cart',
  },
  cartCheckout: {
    path: 'checkout/cart',
    goToPath: () => 'checkout/cart',
  },
  itemCheckout: {
    path: 'checkout/:registryItemId',
    goToPath: (registryItemId: string, quantity?: string) => `checkout/${registryItemId}?q=${quantity}`,
  },
};

export const useRoutePaths = () => {
  const { buildPath } = useRouterHelper();
  const memoizedPaths = useMemo(() => {
    return (Object.keys(routePaths) as RoutesNames[]).reduce((acc, route) => {
      acc[route] = {
        path: buildPath(routePaths[route].path),
        goToPath: routePaths[route].goToPath,
      };
      return acc;
    }, {} as RoutesPaths<RoutesNames>);
  }, [buildPath]);
  return memoizedPaths;
};

export const GuestRegistryRouter: React.FC<{ eventHandle: string }> = ({ eventHandle, children }) => {
  return (
    <RoutesProvider
      isGuestRoute={true}
      handle={eventHandle}
      appUrl="registry"
    >
      {children}
    </RoutesProvider>
  );
};
